(function () {
  function initBar(bar) {
    if (bar.dataset.stickyAtcReady === 'true') return;

    var sectionId = bar.dataset.sectionId;
    var section = document.getElementById('mmp-' + sectionId);
    if (!section) return;

    var mainBtn = section.querySelector('[data-mmp-atc]');
    if (!mainBtn) return;

    bar.dataset.stickyAtcReady = 'true';

    var mainTitle = section.querySelector('.mmp__title.is-active') || section.querySelector('.mmp__title');
    var mainPrice = section.querySelector('[data-mmp-headline-price]');
    var mainCompare = section.querySelector('[data-mmp-headline-compare]');
    var variantIdInput = section.querySelector('[data-mmp-variant-id]');

    // Parse variants JSON blob (single-product section). Used to read compare_at_price
    // which has no dedicated headline element in mnml-main-product.liquid.
    var variantsBlob = document.querySelector('[data-mmp-variants="' + sectionId + '"]');
    var variantsData = [];
    try { if (variantsBlob) variantsData = JSON.parse(variantsBlob.textContent); } catch (e) {}

    var stTitle = bar.querySelector('[data-sticky-atc-title]');
    var stPrice = bar.querySelector('[data-sticky-atc-price]');
    var stCompare = bar.querySelector('[data-sticky-atc-compare]');
    var stImg = bar.querySelector('[data-sticky-atc-img]');
    var stBtn = bar.querySelector('[data-sticky-atc-btn]');
    var stBtnText = bar.querySelector('[data-sticky-atc-btn-text]');
    var mainBtnSpan = mainBtn.querySelector('span');

    function activeImage() {
      var gallery =
        section.querySelector('.mmp__flavor-gallery.is-active') ||
        section.querySelector('[data-mmp-main]') ||
        section.querySelector('.mmp__main') ||
        section;
      return (
        gallery.querySelector('.mmp__slide.is-active img') ||
        gallery.querySelector('img.mmp__main-img') ||
        gallery.querySelector('img')
      );
    }

    function syncTitle() {
      var activeTitle = section.querySelector('.mmp__title.is-active') || mainTitle;
      if (activeTitle && stTitle) stTitle.textContent = activeTitle.textContent.trim();
    }

    function moneyFmt(cents) {
      if (cents == null) return '';
      var amt = cents / 100;
      return '$' + (amt % 1 === 0 ? amt + '.00' : amt.toFixed(2));
    }

    function syncPrice() {
      if (mainPrice && stPrice) stPrice.textContent = mainPrice.textContent.trim();

      if (!stCompare) return;

      // Selling-plan products keep the struck price in the selected option row.
      var checked = section.querySelector('[data-mmp-purchase]:checked');
      var ptype = checked ? (checked.value || checked.getAttribute('data-purchase-type')) : '';
      var optCompare = ptype === 'subscription' ? section.querySelector('[data-mmp-sub-compare]')
        : ptype === 'onetime' ? section.querySelector('[data-mmp-onetime-compare]') : null;
      if (optCompare && !optCompare.hidden && optCompare.textContent.trim()) {
        var cur = window.Shopify && window.Shopify.currency ? ' ' + window.Shopify.currency.active : '';
        stCompare.textContent = optCompare.textContent.trim() + cur;
        stCompare.hidden = false;
        return;
      }

      // Prefer the DOM element (multi-section has [data-mmp-headline-compare]).
      if (mainCompare && !mainCompare.hidden && mainCompare.textContent.trim()) {
        stCompare.textContent = mainCompare.textContent.trim();
        stCompare.hidden = false;
        return;
      }

      // Fallback: derive compare_at_price from the variants JSON (single-product section).
      if (variantsData.length && variantIdInput) {
        var vid = variantIdInput.value;
        // Use loose equality so string/number mismatches don't matter.
        var variant = variantsData.find(function (v) { return v.id == vid; }); // eslint-disable-line eqeqeq
        if (variant && variant.compare_at_price && variant.compare_at_price > variant.price) {
          var currency = window.Shopify && window.Shopify.currency ? ' ' + window.Shopify.currency.active : ' USD';
          stCompare.textContent = moneyFmt(variant.compare_at_price) + currency;
          stCompare.hidden = false;
          return;
        }
      }

      stCompare.hidden = true;
    }

    function syncImage() {
      if (!stImg) return;
      var img = activeImage();
      if (img && img.currentSrc) {
        stImg.src = img.currentSrc;
        stImg.hidden = false;
      } else if (img && img.src) {
        stImg.src = img.src;
        stImg.hidden = false;
      }
    }

    function syncAvailability() {
      var disabled = mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true';
      if (stBtn) {
        stBtn.disabled = disabled;
        stBtn.classList.toggle('sticky-atc__btn--loading', mainBtn.classList.contains('loading'));
      }
      if (stBtnText && mainBtnSpan) stBtnText.textContent = mainBtnSpan.textContent.trim();
    }

    function syncAll() {
      syncTitle();
      syncPrice();
      syncImage();
      syncAvailability();
    }

    syncAll();

    var observerTargets = [
      mainPrice,
      mainBtn,
      mainCompare,
      section.querySelector('.mmp__title'),
      // Watch the price wrapper so hidden-attribute toggles on compare sibling are caught.
      section.querySelector('[data-mmp-headline-price-wrap]'),
    ].filter(Boolean);
    var mo = new MutationObserver(function () {
      syncAll();
    });
    observerTargets.forEach(function (node) {
      mo.observe(node, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true,
      });
    });
    // Watch the wider info column so flavor/variant toggles re-sync title and image.
    var infoCol = section.querySelector('.mmp__info') || section;
    mo.observe(infoCol, { attributes: true, attributeFilter: ['class'], subtree: true });

    // Re-sync when the user toggles Subscribe / One-Time (or any option input).
    section.addEventListener('change', syncAll);

    // Delegate the click to the real add-to-cart button.
    if (stBtn) {
      stBtn.addEventListener('click', function () {
        if (stBtn.disabled) return;
        mainBtn.click();
      });
    }

    // Show the bar only while the main ATC button is out of view.
    function setVisible(visible) {
      bar.classList.toggle('sticky-atc--visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            setVisible(!entry.isIntersecting);
          });
        },
        { root: null, threshold: 0 }
      );
      io.observe(mainBtn);
    } else {
      setVisible(false);
    }
  }

  function init() {
    document.querySelectorAll('[data-sticky-atc]').forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when sections are reloaded in the theme editor.
  document.addEventListener('shopify:section:load', init);
})();
